import { HttpErrorResponse } from '@angular/common/http';
import { createReducer, on } from '@ngrx/store';
import { TutorialVideoSummary } from 'brain-data/model/tutorial-video.model';
import {
  deleteTutorialVideoSuccess,
  loadTutorialVideos,
  loadTutorialVideosError,
  loadTutorialVideosSuccess,
  updateTutorialVideoSuccess,
  uploadTutorialVideoSuccess,
} from '../actions/tutorial-video.action';

export default interface TutorialVideoState {
  videos: TutorialVideoSummary[];
  loading: boolean;
  loaded: boolean;
  error?: HttpErrorResponse;
}

export const initialState: TutorialVideoState = {
  videos: [],
  loading: false,
  loaded: false,
};

const sortById = (a: TutorialVideoSummary, b: TutorialVideoSummary) =>
  a.tutorialId.localeCompare(b.tutorialId);

export const reducer = createReducer(
  initialState,

  on(loadTutorialVideos, (state): TutorialVideoState => ({ ...state, loading: true, error: undefined })),
  on(loadTutorialVideosSuccess, (state, { videos }): TutorialVideoState => ({
    ...state,
    videos: [...videos].sort(sortById),
    loading: false,
    loaded: true,
  })),
  on(loadTutorialVideosError, (state, { error }): TutorialVideoState => ({
    ...state,
    loading: false,
    error,
  })),

  on(uploadTutorialVideoSuccess, (state, { video }): TutorialVideoState => ({
    ...state,
    videos: [...state.videos.filter(v => v.tutorialId !== video.tutorialId), video].sort(sortById),
  })),

  on(updateTutorialVideoSuccess, (state, { previousId, video }): TutorialVideoState => ({
    ...state,
    videos: [...state.videos.filter(v => v.tutorialId !== previousId && v.tutorialId !== video.tutorialId), video].sort(sortById),
  })),

  on(deleteTutorialVideoSuccess, (state, { tutorialId }): TutorialVideoState => ({
    ...state,
    videos: state.videos.filter(v => v.tutorialId !== tutorialId),
  })),
);
